/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type member_member$ref = any;
export type Provider = "CNP" | "COGNITO" | "GOOGLE" | "KEYCLOAK" | "MICROSOFT_SIA_PARTNERS" | "ONE_ACCOUNT" | "ONE_ACCOUNT_AXA" | "PASS_AXA" | "STRATUMN" | "%future added value";
export type OrganizationFilter = {|
  rowId?: ?BigIntFilter,
  name?: ?StringFilter,
  description?: ?StringFilter,
  avatar?: ?StringFilter,
  domainName?: ?StringFilter,
  accountId?: ?BigIntFilter,
  createdAt?: ?DatetimeFilter,
  updatedAt?: ?DatetimeFilter,
  providers?: ?ProviderListFilter,
  canInsert?: ?BooleanFilter,
  canSelect?: ?BooleanFilter,
  canUpdate?: ?BooleanFilter,
  organizationMemberLicensesLeft?: ?IntFilter,
  organizationOwnerLicensesLeft?: ?IntFilter,
  and?: ?$ReadOnlyArray<OrganizationFilter>,
  or?: ?$ReadOnlyArray<OrganizationFilter>,
  not?: ?OrganizationFilter,
|};
export type BigIntFilter = {|
  isNull?: ?boolean,
  equalTo?: ?any,
  notEqualTo?: ?any,
  distinctFrom?: ?any,
  notDistinctFrom?: ?any,
  in?: ?$ReadOnlyArray<any>,
  notIn?: ?$ReadOnlyArray<any>,
  lessThan?: ?any,
  lessThanOrEqualTo?: ?any,
  greaterThan?: ?any,
  greaterThanOrEqualTo?: ?any,
|};
export type StringFilter = {|
  isNull?: ?boolean,
  equalTo?: ?string,
  notEqualTo?: ?string,
  distinctFrom?: ?string,
  notDistinctFrom?: ?string,
  in?: ?$ReadOnlyArray<string>,
  notIn?: ?$ReadOnlyArray<string>,
  lessThan?: ?string,
  lessThanOrEqualTo?: ?string,
  greaterThan?: ?string,
  greaterThanOrEqualTo?: ?string,
  includes?: ?string,
  notIncludes?: ?string,
  includesInsensitive?: ?string,
  notIncludesInsensitive?: ?string,
  startsWith?: ?string,
  notStartsWith?: ?string,
  startsWithInsensitive?: ?string,
  notStartsWithInsensitive?: ?string,
  endsWith?: ?string,
  notEndsWith?: ?string,
  endsWithInsensitive?: ?string,
  notEndsWithInsensitive?: ?string,
  like?: ?string,
  notLike?: ?string,
  likeInsensitive?: ?string,
  notLikeInsensitive?: ?string,
  similarTo?: ?string,
  notSimilarTo?: ?string,
|};
export type DatetimeFilter = {|
  isNull?: ?boolean,
  equalTo?: ?any,
  notEqualTo?: ?any,
  distinctFrom?: ?any,
  notDistinctFrom?: ?any,
  in?: ?$ReadOnlyArray<any>,
  notIn?: ?$ReadOnlyArray<any>,
  lessThan?: ?any,
  lessThanOrEqualTo?: ?any,
  greaterThan?: ?any,
  greaterThanOrEqualTo?: ?any,
|};
export type ProviderListFilter = {|
  isNull?: ?boolean,
  equalTo?: ?$ReadOnlyArray<?Provider>,
  notEqualTo?: ?$ReadOnlyArray<?Provider>,
  distinctFrom?: ?$ReadOnlyArray<?Provider>,
  notDistinctFrom?: ?$ReadOnlyArray<?Provider>,
  anyEqualTo?: ?Provider,
  anyNotEqualTo?: ?Provider,
|};
export type BooleanFilter = {|
  isNull?: ?boolean,
  equalTo?: ?boolean,
  notEqualTo?: ?boolean,
  distinctFrom?: ?boolean,
  notDistinctFrom?: ?boolean,
  in?: ?$ReadOnlyArray<boolean>,
  notIn?: ?$ReadOnlyArray<boolean>,
|};
export type IntFilter = {|
  isNull?: ?boolean,
  equalTo?: ?number,
  notEqualTo?: ?number,
  distinctFrom?: ?number,
  notDistinctFrom?: ?number,
  in?: ?$ReadOnlyArray<number>,
  notIn?: ?$ReadOnlyArray<number>,
  lessThan?: ?number,
  lessThanOrEqualTo?: ?number,
  greaterThan?: ?number,
  greaterThanOrEqualTo?: ?number,
|};
export type MemberFilter = {|
  userId?: ?BigIntFilter,
  accountId?: ?BigIntFilter,
  reader?: ?BooleanFilter,
  admin?: ?BooleanFilter,
  leader?: ?BooleanFilter,
  collaborator?: ?BooleanFilter,
  email?: ?StringFilter,
  name?: ?StringFilter,
  and?: ?$ReadOnlyArray<MemberFilter>,
  or?: ?$ReadOnlyArray<MemberFilter>,
  not?: ?MemberFilter,
|};
export type TeamFilter = {|
  rowId?: ?BigIntFilter,
  name?: ?StringFilter,
  description?: ?StringFilter,
  avatar?: ?StringFilter,
  organizationId?: ?BigIntFilter,
  accountId?: ?BigIntFilter,
  createdAt?: ?DatetimeFilter,
  updatedAt?: ?DatetimeFilter,
  email?: ?StringFilter,
  canInsert?: ?BooleanFilter,
  canUpdate?: ?BooleanFilter,
  and?: ?$ReadOnlyArray<TeamFilter>,
  or?: ?$ReadOnlyArray<TeamFilter>,
  not?: ?TeamFilter,
|};
export type memberRootQueryVariables = {|
  userRowId: any,
  organizationFilter?: ?OrganizationFilter,
  memberFilter?: ?MemberFilter,
  teamFilter?: ?TeamFilter,
|};
export type memberRootQueryResponse = {|
  +userByRowId: ?{|
    +$fragmentRefs: member_member$ref
  |}
|};
export type memberRootQuery = {|
  variables: memberRootQueryVariables,
  response: memberRootQueryResponse,
|};
*/


/*
query memberRootQuery(
  $userRowId: BigInt!
  $organizationFilter: OrganizationFilter
  $memberFilter: MemberFilter
  $teamFilter: TeamFilter
) {
  userByRowId(rowId: $userRowId) {
    ...member_member_KZ2Wb
    id
  }
}

fragment member_member_KZ2Wb on User {
  ...removeOrgMemberModal_member_2dhxFh
  ...removeTeamMemberModal_member_2jn8eO
  id
  rowId
  name
  email
  avatar
  canUpdate
  organizations(filter: $organizationFilter) {
    nodes {
      rowId
      canUpdate
      account {
        members(filter: $memberFilter) {
          nodes {
            admin
          }
        }
        id
      }
      id
    }
  }
  teams(filter: $teamFilter) {
    totalCount
    nodes {
      id
      rowId
      name
      avatar
      canUpdate
    }
  }
}

fragment removeOrgMemberModal_member_2dhxFh on User {
  id
  rowId
  name
  email
  organizations(filter: $organizationFilter) {
    nodes {
      id
      rowId
      name
    }
  }
  teams(filter: $teamFilter) {
    totalCount
    nodes {
      id
      name
    }
  }
}

fragment removeTeamMemberModal_member_2jn8eO on User {
  name
  id
  rowId
  teams(filter: $teamFilter) {
    nodes {
      id
      rowId
      name
      organization {
        rowId
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userRowId",
    "type": "BigInt!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationFilter",
    "type": "OrganizationFilter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberFilter",
    "type": "MemberFilter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamFilter",
    "type": "TeamFilter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rowId",
    "variableName": "userRowId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUpdate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "memberRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "userByRowId",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "memberFilter",
                "variableName": "memberFilter"
              },
              {
                "kind": "Variable",
                "name": "organizationFilter",
                "variableName": "organizationFilter"
              },
              {
                "kind": "Variable",
                "name": "teamFilter",
                "variableName": "teamFilter"
              }
            ],
            "kind": "FragmentSpread",
            "name": "member_member"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "memberRootQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "userByRowId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "filter",
                "variableName": "organizationFilter"
              }
            ],
            "concreteType": "OrganizationsConnection",
            "kind": "LinkedField",
            "name": "organizations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "filter",
                            "variableName": "memberFilter"
                          }
                        ],
                        "concreteType": "MembersConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "admin",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "filter",
                "variableName": "teamFilter"
              }
            ],
            "concreteType": "TeamsConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "memberRootQuery",
    "operationKind": "query",
    "text": "query memberRootQuery(\n  $userRowId: BigInt!\n  $organizationFilter: OrganizationFilter\n  $memberFilter: MemberFilter\n  $teamFilter: TeamFilter\n) {\n  userByRowId(rowId: $userRowId) {\n    ...member_member_KZ2Wb\n    id\n  }\n}\n\nfragment member_member_KZ2Wb on User {\n  ...removeOrgMemberModal_member_2dhxFh\n  ...removeTeamMemberModal_member_2jn8eO\n  id\n  rowId\n  name\n  email\n  avatar\n  canUpdate\n  organizations(filter: $organizationFilter) {\n    nodes {\n      rowId\n      canUpdate\n      account {\n        members(filter: $memberFilter) {\n          nodes {\n            admin\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n  teams(filter: $teamFilter) {\n    totalCount\n    nodes {\n      id\n      rowId\n      name\n      avatar\n      canUpdate\n    }\n  }\n}\n\nfragment removeOrgMemberModal_member_2dhxFh on User {\n  id\n  rowId\n  name\n  email\n  organizations(filter: $organizationFilter) {\n    nodes {\n      id\n      rowId\n      name\n    }\n  }\n  teams(filter: $teamFilter) {\n    totalCount\n    nodes {\n      id\n      name\n    }\n  }\n}\n\nfragment removeTeamMemberModal_member_2jn8eO on User {\n  name\n  id\n  rowId\n  teams(filter: $teamFilter) {\n    nodes {\n      id\n      rowId\n      name\n      organization {\n        rowId\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2a2de8dc989bad0b272e93891392ebf9';

module.exports = node;
